import { OnboardingSkeleton } from '@/features/onboarding/components/OnboardingSkeleton';
import { AppShellSkeleton } from '@/layouts/MainLayout/AppShellSkeleton';

function isOnboardingPath(pathname: string): boolean {
  return /^\/[^/]+\/all\/?$/.test(pathname);
}

export function RouteLoadingFallback() {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '/';

  if (isOnboardingPath(pathname)) {
    return <OnboardingSkeleton />;
  }

  return <AppShellSkeleton />;
}
